import httpClient from '../../shared/services/httpClient';

export const UploadMedia = async (placeId: number, media: File, type: string, token?: string) => {
  const formData = new FormData();
  formData.append('file', media);
  formData.append('type', type);
  const headers: Record<string, string> = { 'Content-Type': 'multipart/form-data' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await httpClient.post(`/media/upload/place/${placeId}`, formData, { headers });
  return response.data;
};

export const UploadMediaColletionName = async (
  placeId: number,
  collectionId: number,
  media: File,
  type: string,
  token?: string,
) => {
  const formData = new FormData();
  formData.append('file', media);
  formData.append('type', type);
  const headers: Record<string, string> = { 'Content-Type': 'multipart/form-data' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await httpClient.post(
    `/media/upload/place/${placeId}/collection/${collectionId}`,
    formData,
    { headers },
  );
  return response.data;
};
